import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OnboardingStorageService } from '@services';
import {
  IconIllustrativeName,
  IconName,
  PalleteColor,
} from 'nanaykuna-ui-kit/loader';

interface OnboardingStep {
  illustration?: IconIllustrativeName;
  iconName?: IconName;
  iconFill?: PalleteColor;
  badgeClass?: string;
  title: string;
  subtitle?: string;
  body: string;
  buttonLabel: string;
}

const STEPS: OnboardingStep[] = [
  {
    illustration: 'i-communication',
    title: '¡Hay algo nuevo que debes saber!',
    body: 'Ahora los registros tienen un plazo.\nSi el plazo vence sin ser confirmado o rechazado, el registro desaparecerá de forma permanente.',
    buttonLabel: 'Siguiente',
  },
  {
    iconName: 'clock',
    iconFill: 'critical-300',
    badgeClass: 'bg-critical-100',
    title: 'Urgente',
    subtitle: '(1 a 3 días restantes)',
    body: 'El registro está próximo a vencer.\nRevísalo cuanto antes para evitar que desaparezca.',
    buttonLabel: 'Siguiente',
  },
  {
    iconName: 'clock',
    iconFill: 'warning-300',
    badgeClass: 'bg-warning-100',
    title: 'Próximo a vencer',
    subtitle: '(4 a 8 días restantes)',
    body: 'El registro aún está dentro del plazo, pero se acerca su fecha límite.\nRevísalo con anticipación.',
    buttonLabel: 'Entendido',
  },
];

@Component({
  standalone: false,
  selector: 'digicem-onboarding-tour-dialog',
  templateUrl: './onboarding-tour-dialog.component.html',
})
export class OnboardingTourDialogComponent {
  protected readonly steps = STEPS;
  protected currentStep = 0;

  constructor(
    private dialogRef: MatDialogRef<OnboardingTourDialogComponent>,
    private onboardingStorageService: OnboardingStorageService,
  ) {}

  protected get step(): OnboardingStep {
    return this.steps[this.currentStep];
  }

  protected get isLastStep(): boolean {
    return this.currentStep === this.steps.length - 1;
  }

  protected get bodyLines(): string[] {
    return this.step.body.split('\n');
  }

  protected next(): void {
    if (this.isLastStep) {
      this.finish();
      return;
    }
    this.currentStep += 1;
  }

  protected finish(): void {
    // Mark seen unconditionally, then close no matter what — a throwing write
    // must never trap the seller behind this disableClose dialog. The storage
    // service already swallows its own errors; this guard is belt-and-suspenders.
    try {
      this.onboardingStorageService.markApprovalDeadlineOnboardingSeen();
    } catch {
      // ignored on purpose
    }
    this.dialogRef.close();
  }
}
